module.exports = __webpack_public_path__ + "static/img/1.3be110f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/1.png
// module id = KmH6
// module chunks = 0